export default __webpack_public_path__ + "static/media/chickennuggets@2x.e656dd46.jpg";